import axios from "axios";

export const DEBOUNCE_TIME = 1000;

export function logSearchActivity(activitySource, searchString, numResults = null) {
    const activityData = {
        searchString,
        numResults
    };
    logActivity("Search", activitySource, activityData);
}

export function logTabChangeActivity(activitySource, tabName) {
    logActivity("Tab Change", activitySource, {tab: tabName});
}

export function logActivity(activityName, activitySource, activityData = {}) {
    const logData = {
        activityName,
        activitySource,
        activityData
    };

    axios.post("/log-activity", logData);
}
